import { useQuery } from '@tanstack/react-query'
import { fetchUsageMetrics, type UsageParams, type UsageResponse } from '@/api/usage'

export function useUsageMetrics(params: UsageParams) {
  return useQuery<UsageResponse>({
    queryKey: ['admin', 'usage', params],
    queryFn: () => fetchUsageMetrics(params),
  })
}
